import React from 'react';
import AppHeaderStyles from './AppHeader.module.css';

const HamburgerMenuIcon = ({ dataTestId }) => {
  const mainNavIconClass = AppHeaderStyles.mainNavIcon;
  const mainNavIconFillClass = AppHeaderStyles.mainNavIconFill;
  return (
    <svg
      data-testid={dataTestId}
      className={`${mainNavIconClass} ${mainNavIconFillClass}`}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xlinkHref="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 24 18"
      style={{ fill: '#3B3B3A' }}
    >
      <title>Main Navigation Button</title>
      <path d="M22,4H2C0.9,4,0,3.1,0,2l0,0c0-1.1,0.9-2,2-2h20c1.1,0,2,0.9,2,2l0,0C24,3.1,23.1,4,22,4z" />
      <path
        className="st0"
        d="M22,11H2c-1.1,0-2-0.9-2-2l0,0c0-1.1,0.9-2,2-2h20c1.1,0,2,0.9,2,2l0,0C24,10.1,23.1,11,22,11z"
      />
      <path
        className="st0"
        d="M22,18H2c-1.1,0-2-0.9-2-2l0,0c0-1.1,0.9-2,2-2h20c1.1,0,2,0.9,2,2l0,0C24,17.1,23.1,18,22,18z"
      />
    </svg>
  );
};

export default HamburgerMenuIcon;
